export function getPlayerParams(videoSrc) {
    let srcDefaults = "autoplay=1";//&mute=1
    let curSrc = videoSrc;
    let isMp4VideoSrc = curSrc.indexOf(".mp4") > -1;
    let src = curSrc;

    if (!isMp4VideoSrc) {
        src = src + (src.indexOf("?") > -1 ? "&" : "?") + srcDefaults;
    }

    let playerTemplate = isMp4VideoSrc ? "<video controls autoplay name=\"media\"><source src=\"" + src + "\" type=\"video/mp4\"></video>" : "<iframe title=\"video iframe\" src=\"" + src + "\" frameborder=\"0\"  allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>";

    return {
        src: src,
        template: playerTemplate
    };
}


// WEBPACK FOOTER //
// ./assets/js/modules/get-player-params.js